import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { isSessionValid, parseIAT } from '@shared/helpers/system.helper';
import dayjs from 'dayjs';
import { EMPTY, Observable } from 'rxjs';
import { LocalStorageService } from '../services/local-storage.service';
import { NotificationsService } from '../services/notifications.service';
const TOKEN_HEADER_KEY = 'Authorization';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  creationTime: number = 0;
  lastJwt: string | null = null;

  constructor(
    private router: Router,
    private storage: LocalStorageService,
    private notification: NotificationsService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('jwt');

    if (token && this.check(token)) {
      this.lastJwt = token;
      const authReq = req.clone({
        headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token),
      });
      return next.handle(authReq);
    } else if (token) {
      this.cleanAndDrop();
      this.notification.warning('Session Closed', 'Session is expired. Please log in again', 4000);
      return EMPTY;
    }

    return next.handle(req);
  }

  public checkTokenValidity(jwt: string | null): boolean {
    if (jwt) {
      let time = parseIAT(jwt);

      if (Number(time)) {
        const timeInMiliseconds = Number(time) * 1000;
        if (dayjs().diff(dayjs(timeInMiliseconds), 'hours') < 24) {
          this.creationTime = timeInMiliseconds;
          return true;
        }
      }
      return false;
    }

    return true;
  }

  public check(jwt: string | null): boolean {
    if (this.creationTime && this.lastJwt === jwt) {
      return isSessionValid(this.creationTime);
    } else {
      return this.checkTokenValidity(jwt);
    }
  }

  public cleanAndDrop() {
    localStorage.clear();
    this.storage.changeLoggedIn(false);
    this.router.navigate(['/login']);
  }
}
